import type { Campaign } from '@/lib/campaigns'
import { buildWhatsAppChatHref } from '@/lib/whatsapp-link'

/** Converte dados antigos de contato em um link único para os dois botões. */
export function campaignWhatsAppLinkForEditor(
  campaign: Pick<Campaign, 'whatsapp_button_url' | 'public_contact_url'>
): string {
  const value =
    campaign.whatsapp_button_url?.trim() || campaign.public_contact_url?.trim() || ''
  if (!value) return ''
  if (/^https?:\/\//i.test(value)) return value
  if (/^(wa\.me|api\.whatsapp\.com)\//i.test(value)) return `https://${value}`
  return buildWhatsAppChatHref(value) ?? ''
}
